<template>
  <div id="drug">
    <el-form inline size="small">
      <el-form-item label="手机号">
        <el-input
          v-model="searchForm.phoneNumber"
          placeholder="请输入手机号"
          clearable
        />
      </el-form-item>
      <el-form-item label="医院名称">
        <el-input
          v-model="searchForm.hospitalName"
          placeholder="请输入医院名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="联系人">
        <el-input
          v-model="searchForm.contact"
          placeholder="请输入联系人"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          搜索
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="drugPage.list"
      row-key="id"
      :cell-style="{ padding: '6px' }"
      :header-cell-style="{ background: '#f8f8f9' }"
      :height="getTableHeight()"
    >
      <el-table-column prop="hospitalName" label="医院名称" />
      <el-table-column prop="phoneNumber" label="手机号" />
      <el-table-column prop="password" label="密码" />
      <el-table-column prop="contact" label="联系人" />
      <el-table-column prop="createTime" label="注册时间" />
      <el-table-column prop="picUrl" label="医疗机构执业许可证"
        >'
        <template slot-scope="scope"
          >'
          <el-image
            style="width: 100px; height: 100px"
            :src="baseUrl + '/files/' + scope.row.picUrl"
            fit="fill"
          />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态"
        >'
        <template slot-scope="scope"
          >'
          <span>{{ scope.row.status ? "通过" : "不通过" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleAudit(scope.row)">
            审核
          </el-button>
          <el-button type="text" size="small" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :total="drugPage.total"
      :current-page="searchForm.pageNum"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @current-change="pageNumChange"
      @size-change="pageSizeChange"
    />
    <el-dialog :visible.sync="showDialogVisible">
      <el-radio-group v-model="reviewFrom.status">
        <el-radio :label="-1">不通过</el-radio>
        <el-radio :label="1">通过</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSuemit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectRegisterList,
  deleteRegister,
  registerReview,
} from "@/api/medicine/register";

export default {
  data() {
    return {
      drugDialogVisible: false,
      showDialogVisible: false,
      drugFormTitle: "",
      drugPage: {
        list: [],
        total: 0,
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        phoneNumber: "",
        hospitalName: "",
        contact: "",
      },
      baseUrl: window.g.BASE_URL,
      reviewFrom: {
        id: "",
        status: "",
      },
    };
  },
  created() {
    selectRegisterList(this.searchForm).then((res) => {
      this.drugPage = res;
    });
  },
  methods: {
    handleSearch() {
      this.searchForm.pageNum = 1;
      selectRegisterList(this.searchForm).then((res) => {
        this.drugLibraryPage = res;
      });
    },
    handleAudit(row) {
      this.showDialogVisible = true;
      this.reviewFrom.id = row.id;
    },
    async handleSuemit() {
      console.log(666);
      await registerReview(this.reviewFrom);
      this.showDialogVisible = false;
      selectRegisterList(this.searchForm).then((res) => {
        this.drugPage = res;
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await deleteRegister(row.id);
          selectRegisterList(this.searchForm).then((res) => {
            this.drugPage = res;
          });
        })
        .catch();
    },

    pageNumChange(pageNum) {
      this.searchForm.pageNum = pageNum;
      selectRegisterList(this.searchForm).then((res) => {
        this.drugPage = res;
      });
    },
    pageSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageNum = 1;
      selectRegisterList(this.searchForm).then((res) => {
        this.drugPage = res;
      });
    },
  },
};
</script>

<style></style>
